var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFourArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6247 3.49992C16.6247 2.85559 17.147 2.33325 17.7913 2.33325H23.333C23.9773 2.33325 24.4997 2.85559 24.4997 3.49992V9.04159C24.4997 9.68592 23.9773 10.2083 23.333 10.2083C22.6887 10.2083 22.1663 9.68592 22.1663 9.04159V4.66659H17.7913C17.147 4.66659 16.6247 4.14425 16.6247 3.49992Z",
    fill: "#878787"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.158 2.67496C24.6136 3.13057 24.6136 3.86926 24.158 4.32488L17.3996 11.0833C16.944 11.5389 16.2053 11.5389 15.7497 11.0833C15.2941 10.6276 15.2941 9.88895 15.7497 9.43334L22.508 2.67496C22.9637 2.21935 23.7024 2.21935 24.158 2.67496Z",
    fill: "#878787"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.49967 16.6249C4.14401 16.6249 4.66634 17.1473 4.66634 17.7916V22.1666H9.04134C9.68567 22.1666 10.208 22.6889 10.208 23.3333C10.208 23.9776 9.68567 24.4999 9.04134 24.4999H3.49967C2.85534 24.4999 2.33301 23.9776 2.33301 23.3333V17.7916C2.33301 17.1473 2.85534 16.6249 3.49967 16.6249Z",
    fill: "#878787"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.083 15.7499C11.5386 16.2055 11.5386 16.9442 11.083 17.3998L4.32463 24.1582C3.86902 24.6138 3.13033 24.6138 2.67472 24.1582C2.2191 23.7026 2.2191 22.9639 2.67472 22.5083L9.43309 15.7499C9.8887 15.2943 10.6274 15.2943 11.083 15.7499Z",
    fill: "#878787"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.333 15.4583C23.9773 15.4583 24.4997 15.9806 24.4997 16.6249V23.3333C24.4997 23.9776 23.9773 24.4999 23.333 24.4999H17.7913C17.147 24.4999 16.6247 23.9776 16.6247 23.3333C16.6247 22.6889 17.147 22.1666 17.7913 22.1666H22.1663V16.6249C22.1663 15.9806 22.6887 15.4583 23.333 15.4583Z",
    fill: "#878787"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7497 15.7499C16.2053 15.2943 16.944 15.2943 17.3996 15.7499L24.158 22.5083C24.6136 22.9639 24.6136 23.7026 24.158 24.1582C23.7024 24.6138 22.9637 24.6138 22.508 24.1582L15.7497 17.3998C15.2941 16.9442 15.2941 16.2055 15.7497 15.7499Z",
    fill: "#878787"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33301 3.49992C2.33301 2.85559 2.85534 2.33325 3.49967 2.33325H9.04134C9.68567 2.33325 10.208 2.85559 10.208 3.49992C10.208 4.14425 9.68567 4.66659 9.04134 4.66659H4.66634V9.04159C4.66634 9.68592 4.14401 10.2083 3.49967 10.2083C2.85534 10.2083 2.33301 9.68592 2.33301 9.04159V3.49992Z",
    fill: "#878787"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.67472 2.67496C3.13033 2.21935 3.86902 2.21935 4.32463 2.67496L11.083 9.43334C11.5386 9.88895 11.5386 10.6276 11.083 11.0833C10.6274 11.5389 9.8887 11.5389 9.43309 11.0833L2.67472 4.32488C2.2191 3.86926 2.2191 3.13057 2.67472 2.67496Z",
    fill: "#878787"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourArrow);
export default __webpack_public_path__ + "static/media/FourArrow.ace9e80c123fd822af6590a665a414f6.svg";
export { ForwardRef as ReactComponent };